/**
 * @desc 获取库存成本
 */
const URL = "/rantion-fulfilment";
import http, { updateResponse } from "@/http";
export function request(body: defs.fulfilment.InventoryCostPushToEbsRequestDto, options?: any) {
  return updateResponse(
    http(URL + `/stockAdjustmentMaster/inventoryCostPushToEbs`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
